export default "__VITE_ASSET__27e51728__"